export default __webpack_public_path__ + "static/media/DefinixIcon-16.fb34516e.png";